export default __webpack_public_path__ + "static/media/subwayDNA-logo-final-14.6569ab38.png";